export const Network = {
  TypeError: {
    BulkOperationTypeMismatch:
      'BulkOperationRequest does not match BulkOperationResponse expectation'
  }
}

export const State = {}
